import styled from "styled-components";
import ConfirmOrder from "@/components/gateway/ConfirmOrder";
// import MazoutLoader from "@/components/_common/MazoutLoader";

const ConfirmOrderPage = () => {
  return (
      <ConfirmationWrapper>
        <ConfirmOrder />
      </ConfirmationWrapper>
  );
};

export default ConfirmOrderPage;

const ConfirmationWrapper = styled.div`
  //background: ${(props) => props.theme.colors.grey};
  display: flex;
  width: 100%;
  flex-direction: column;
`;
